import {connect}      from 'react-redux';
import * as Cookie    from 'js-cookie';  // eslint-disable-line
import getTemplates   from '../store/selectors/getTemplates';
import dataThunks     from '../store/actions/dataThunks';
import sessionActions from '../store/actions/sessionActions';

const mapStateToProps = (state) => ({
  isLoadingLogin     : state.getIn(['sessions', 'isLoading']),
  isLoadingTemplates : state.getIn(['langue', 'isLoadingTemplates']),
  lang               : getTemplates(state),
});

const mapDispatchToProps = (dispatch) => ({
  login(data) {
    return dispatch(dataThunks.login(data));
  },
  setToken() {
    const token = Cookie.get('token');
    dispatch(sessionActions.setToken(token));
    return token;
  },
});

const buildController = (component) => connect(mapStateToProps, mapDispatchToProps)(component);

export default buildController;



// WEBPACK FOOTER //
// ./src/global/globalcontroller.js